module.exports = __webpack_public_path__ + "img/product_111.24b9796.webp";